// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Y8rAv","description":"styles_description__07a4Z"};